import { render, staticRenderFns } from "./viewImage.vue?vue&type=template&id=e80451bc&"
import script from "./viewImage.vue?vue&type=script&lang=js&"
export * from "./viewImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports